import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { IUserProfile } from "MVVM/@types";

import { SocialPills } from "MVVM/Views/Profile/Components/Header/Components/SocialPills";
import { LoadingContent } from "./Components/LoadingContent";
import { SharedFollows } from "../SharedFollows";

interface IContentProps {
  profileUser?: IUserProfile;
  loading?: boolean;
}

export const Content = ({ profileUser, loading }: IContentProps) => {
  return (
    <ContentSection>
      {loading ? (
        <LoadingContent />
      ) : (
        <>
          {profileUser?.sharedFollows &&
            profileUser.sharedFollows.length > 0 && (
              <SharedFollows sharedFollows={profileUser.sharedFollows} />
            )}

          {profileUser?.bio && <BioText my={3}>{profileUser.bio}</BioText>}

          {profileUser && (
            <SocialPillsContainer mt={3} mb={1}>
              <SocialPills variant="small" user={profileUser} />
            </SocialPillsContainer>
          )}
        </>
      )}
    </ContentSection>
  );
};

const ContentSection = styled(Flex)`
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  position: relative;
`;

const BioText = styled(Box)`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: ${({ theme }) => theme.colors.shade300};
  display: -webkit-box;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  max-height: 60px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
`;

const SocialPillsContainer = styled(Box)``;
